import React from "react";
import { connect } from "react-redux";
import { Button, ValidationGroup } from "devextreme-react";
import { openCloseToast, setPreventNavigation, setComunasbyRegionList } from "../../../../Global/actions";
import CardShared from "../../../../Shared/CardUser";

import { setMyData, updateMyData, setFamilyMember } from "./actions";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";

import validaciones from "../../../../../helpers/validaciones";
import ModalMessege from "./modalMessges";
import TextField from "../../../../Shared/fields/TextField";
import SelectField from "../../../../Shared/fields/SelectField";
import NumberField from "../../../../Shared/fields/NumberField";
import DateField from "../../../../Shared/fields/DateField";

class MisDatos extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {

      openModal: false,
      messegeModal: "",
      title: "",
      actionCallModal: null,
      deleteEvent: null,

      bancosValidos: true,
      tipoCtavalid: true,
      nroCtavalid: true,
      comunaDisabled: !props.profile.Address.Region,

      validations: {}
    };
    this.tableRef = React.createRef();
  }

  // componentDidMount() {
  //   if (this.props.originalProfile === null) {
  //     this.props.dispatch(setOrigingProfile(this.props.profile));
  //   }
  // }
  validaDatosBanco = () => {
    const { profile } = this.props;
    let datosValidos = true;

    if (profile.Payment.Bank.Id !== null) {
      if (profile.Payment.AccountType.Id === null) {
        this.setState({ tipoCtavalid: false });
      } else {
        this.setState({ tipoCtavalid: true });
      }

      if (profile.Payment.AccountNumber === null) {
        this.setState({ nroCtavalid: false });
      } else {
        this.setState({ nroCtavalid: true });
      }

      if (this.state.nroCtavalid === false || this.state.tipoCtavalid === false) {
        datosValidos = false;
      }
      this.setState({ bancosValidos: datosValidos });
    } else {
      this.setState({ bancosValidos: datosValidos, nroCtavalid: true, tipoCtavalid: true });
    }
  }

  handleChange = (e, value) => {
    const newProfile = { ...this.props.profile };

    switch (e.element.id) {
      case "MaritalCmbx": {
        if (value) {
          const estadoCivilObject = this.props.listaEstadoCivil.find((item) => item.Cod === value);
          newProfile.MaritalStatus.Id = estadoCivilObject.Cod;
          newProfile.MaritalStatus.Description = estadoCivilObject.Text;
        }
        break;
      }
      case "comunaCmbx": {
        if (value) {
          const commune = this.props.listaComuna.filter((item) => item.IdComuna === e.value).map((r) => r.DescripcionCommuna);
          newProfile.Address.Commune = commune[0];
        } else {
          newProfile.Address.Commune = null;
        }

        break;
      }
      case "regionCmbx": {
        if (value) {
          const region = this.props.listaDirecciones.filter((item) => item.IdRegion === e.value).map((r) => r.DescripcionRegion);
          newProfile.Address.Region = region[0];
          const comunas = this.props.listaDirecciones.filter((item) => item.IdRegion === e.value).map((c) => c.Comunas);
          const sortedComunas = comunas[0].sort(validaciones.sortComunas);
          this.props.dispatch(setComunasbyRegionList(sortedComunas));
          this.setState({ comunaDisabled: false });
        } else {
          newProfile.Address.Region = null;
          newProfile.Address.Commune = null;
          this.setState({ comunaDisabled: true });
        }
        break;
      }
      case "IsapreCmbx": {
        if (value) {
          const isapreObject = this.props.listaIsapres.find((item) => item.CodigoIsapre === value);
          newProfile.LegalDiscount.Isapre.Id = isapreObject.CodigoIsapre;
          newProfile.LegalDiscount.Isapre.Description = isapreObject.Isapre;
        } else {
          newProfile.LegalDiscount.Isapre.Id = null;
          newProfile.LegalDiscount.Isapre.Description = null;
        }

        break;
      }
      case "AfpCmbx": {
        if (value) {
          const afpObject = this.props.listaAfp.find((item) => item.Cod === value);
          newProfile.LegalDiscount.AFP.Id = afpObject.Cod;
          newProfile.LegalDiscount.AFP.Description = afpObject.Text;
        } else {
          newProfile.LegalDiscount.AFP.Id = null;
          newProfile.LegalDiscount.AFP.Description = null;
        }
        break;
      }
      case "ProfesionCmbx": {
        if (value) {
          const ocupationObject = this.props.listaProfesiones.find((item) => item.CodigoProfesion === value);
          newProfile.LaborInformation.Ocupation.Id = ocupationObject.CodigoProfesion;
          newProfile.LaborInformation.Ocupation.Description = ocupationObject.Ocupacion;
        } else {
          newProfile.LaborInformation.Ocupation.Id = null;
          newProfile.LaborInformation.Ocupation.Description = null;
        }

        break;
      }
      case "SectorCmbx": {
        if (value) {
          const rubroObject = this.props.listaRubro.find((item) => item.Codigo === value);
          newProfile.LaborInformation.Sector.Id = rubroObject.Codigo;
          newProfile.LaborInformation.Sector.Description = rubroObject.Rubro;
        } else {
          newProfile.LaborInformation.Sector.Id = null;
          newProfile.LaborInformation.Sector.Description = null;
        }

        break;
      }
      case "TipoJornadaCmbx": {
        if (value) {
          const jornadaObject = this.props.listaTipoJornada.find((item) => item.Codigo === value);
          newProfile.LaborInformation.DayType.Id = jornadaObject.Codigo;
          newProfile.LaborInformation.DayType.Description = jornadaObject.Jornada;
        } else {
          newProfile.LaborInformation.DayType.Id = null;
          newProfile.LaborInformation.DayType.Description = null;
        }


        break;
      }
      case "BancosCmbx": {
        if (value) {
          const bancoObject = this.props.listaBancos.find((item) => item.Codigo === value);

          newProfile.Payment.Bank.Id = bancoObject.Codigo;
          newProfile.Payment.Bank.Description = bancoObject.Banco;
          this.validaDatosBanco();
        } else {
          newProfile.Payment.Bank.Id = null;
          newProfile.Payment.Bank.Description = null;
          newProfile.Payment.AccountType.Id = null;
          newProfile.Payment.AccountNumber = null;
          this.validaDatosBanco();
        }


        break;
      }
      case "TipoCuentaCmbx": {
        if (value) {
          const accountTypeObject = this.props.listaTiposCuenta.find((item) => item.Codigo === value);
          newProfile.Payment.AccountType.Id = accountTypeObject.Codigo;
          newProfile.Payment.AccountType.Description = accountTypeObject.Cuenta;
          this.validaDatosBanco();
        } else {
          newProfile.Payment.AccountType.Id = null;
          newProfile.Payment.AccountType.Description = null;
          this.validaDatosBanco();
        }
        break;
      }
      default:
        break;
    }
    this.compareObject();
  }

  updateFamilyMember = (member) => {
    const familyMember = member.Id;
    this.props.dispatch(setFamilyMember(familyMember));
    this.setState({
      openModal: true,
      title: "Modificar Miembro Familiar",
      messegeModal: null,
      actionCallModal: "UdpateFamilyMember",


    });
  }

  handleBeforeRemove = (member) => {
    const familyMember = member.Id;
    this.props.dispatch(setFamilyMember(familyMember));
    this.setState({
      openModal: true,
      title: "Eliminacion",
      messegeModal: `¿ Seguro desea eliminar a ${familyMember.FullName} ?`,
      actionCallModal: "eliminarGrupoFamiliar",


    });
  }

  handleRemove = () => {
    const event = this.state.deleteEvent;
    const toast = {};
    const {
      profile,
    } = this.props;
    const FamilyGroup = this.props.profile.FamilyGroup ? this.props.profile.FamilyGroup.filter((obj) => obj.Rut !== event.key.Rut) : [];
    profile.FamilyGroup = FamilyGroup;
    this.props.dispatch(setMyData(profile));
    this.setState({
      openModal: false,
    });
    toast.isToastOpen = true;
    toast.msgToast = "Familiar eliminado, guarde los cambios";
    toast.typeStyle = "success";
    toast.displayTime = 5000
    this.props.dispatch(openCloseToast(toast));
    this.compareObject();
  }

  closeModal = () => {
    this.setState({
      openModal: false,
      messegeModal: null,
      title: null,
      actionCallModal: null,
      deleteEvent: null,
    });
  }

  handleAdd = () => {
    this.setState({
      openModal: true,
      title: "Nuevo Familiar",
      messegeModal: null,
      actionCallModal: "addFamilyMember",

    });
  }

  doUpdateMyData = () => {
    const {
      profile,
    } = this.props;
    this.validaDatosBanco();
    if (this.state.bancosValidos) {
      this.props.dispatch(updateMyData(profile));
    }
  }

  setValidation = (key, isValid, message) => {
    if(isValid) {
      if(key in this.state.validations)
      {
        this.setState(({ validations }) => {
          const { [key]: discarted, ...newValidations } = validations;

          return { validations: {...newValidations } };
        });
      }
    } else {
      this.setState(({ validations }) => ({ validations: {...validations, [key]: message } }));
    }
  }

  isValid = () => Object.keys(this.state.validations).length === 0;

  changeForm = (e) => {
    // const { value } = e;
    const newProfile = { ...this.props.profile };

    switch (e.element.id) {
      case "Street": {
        newProfile.Address = { ...this.props.profile.Address, Street: e.value };// value;
        break;
      }
      case "Number": {
        newProfile.Address = { ...this.props.profile.Address, Number: e.value };
        break;
      }
      case "BirthDate": {
        newProfile.BirthDate = e.value
        break;
      }
      case "AccountNumber": {
        if (e.value) {
          this.setState({ nroCtavalid: true });
        } else {
          this.setState({ nroCtavalid: false });
        }
        newProfile.Payment = { ...this.props.profile.Payment, AccountNumber: e.value };

        break;
      }
      case "Name":
      case "MiddleName":
      case "FatherLastName":
      case "MotherLastName":
      {
        newProfile[e.element.id] = e.value;

        if(e.element.id !== 'MiddleName' && e.element.id !== 'MotherLastName' && !e.value)
          this.setValidation(e.element.id, false, 'Campo es requerido');
        else
          this.setValidation(e.element.id, true);
        break;
      }
      case "CellPhoneNumber": {
        newProfile.CellPhoneNumber = e.value;
        break;
      }
      default:
        break;
    }
    this.compareObject();
    this.props.dispatch(setMyData(newProfile));
  }

  compareObject() {
    if (this.props.preventNavigation === false) {
      this.props.dispatch(setPreventNavigation(true));
    }
  }

  callValidationRut = (e) => {
    if (validaciones.validateRut(e.value)) {
      return true;
    }
    return false;
  }

  renderGrupoFamiliar() {
    const userData = [];

    this.props.profile.FamilyGroup.forEach((item) => {
      const Data = {};

      const Relationship = this.props.listaParentesco.filter((r) => r.Codigo === item.Relationship).map((y) => y.Parentesco)[0];
      Data.className = "col-12";
      Data.Header = item.FullName;
      Data.Id = { Rut: item.Rut, FullName: item.FullName, Relationship: item.Relationship };

      Data.TextCircle = `${validaciones.getFirstLetter(item.FullName)}`;
      Data.List = [
        { icono: null, text: Relationship, disabled: true },
        { icono: null, text: validaciones.formatRut(item.Rut, { showDots: true, showHyphen: true }), disabled: true },

      ];
      Data.background = "#004A52";
      Data.Button = {
        visible: true,
        BtnList: [{
          id: "BtnEdit",
          className: "material-icons",
          type: "success",
          style: {
            position: "absolute",
            right: 0,
            top: 0,
            backgroundColor: "Transparent",
            border: "none",

          },
          icon: {
            visible: true,
            color: "#004A52",
            name: "edit",
          },
          onClickMethod: this.updateFamilyMember,

        },
        {
          id: "BtnDelete",
          className: "material-icons",
          type: "success",
          style: {
            position: "absolute",
            right: 20,
            top: 0,
            backgroundColor: "Transparent",
            border: "none",

          },
          icon: {
            visible: true,
            color: "#004A52",
            name: "delete",
          },
          onClickMethod: this.handleBeforeRemove,

        },
        ],


      };

      userData.push(Data);
    });

    return (
      <React.Fragment >

        <div className="dx-form-group-with-caption dx-form-group dx-group-colcount-2">
          <span className="dx-form-group-caption" style={{ color: "#004A52", marginTop: 40 }} >Datos familiares</span>
          <Button
            text="Agregar Familiar"
            type="default"
            icon="add"
            style={{
              position: "absolute",
              right: 0,
            }}
            onClick={this.handleAdd}
          />
        </div>
        <div style={{ marginLeft: 3, paddingTop: 10 }}>
          <CardShared userData={userData} />
        </div>
      </React.Fragment>
    );
  }

  render() {
    const newprofile = { ...this.props.profile };

    return (
      <div className="zero row">
        <ModalMessege
          open={this.state.openModal}
          title={this.state.title}
          message={this.state.messegeModal}
          idFamilyMember={this.state.idFamilyMember}
          closeModalCall={this.closeModal}
          actionCallModal={this.state.actionCallModal}
        />

        <div className="col-12 zero" style={{ minHeight: 400, maxWidth: 525 }} >
          {this.props.isLoading && <LoadingOverlay />}
          <div className="col-12 zero miCuenta" >
            <div style={{ marginBottom: 5 }}>
              <p style={{ fontSize: 16 }}>
                Los datos personales serán utilizados exclusivamente para acelerar el proceso de gestión en ACHS Virtual.
              </p>
            </div>

            <ValidationGroup>
              <div className="datos dx-form dx-widget dx-visibility-change-handler">
                <div className="datos dx-form-group-with-caption dx-form-group dx-group-colcount-1">
                  <span className="dx-form-group-caption datos-title">Datos generales</span>
                  <div className="dx-form-group-content">
                    <TextField
                      label="Nombre"
                      id="Name"
                      value={newprofile.Name}
                      onChange={this.changeForm}
                      required
                    />
                    <TextField
                      label="Segundo Nombre"
                      id="MiddleName"
                      value={newprofile.MiddleName}
                      onChange={this.changeForm}
                    />
                    <TextField
                      label="Apellido Paterno"
                      id="FatherLastName"
                      value={newprofile.FatherLastName}
                      onChange={this.changeForm}
                      required
                    />
                    <TextField
                      label="Apellido Materno"
                      id="MotherLastName"
                      value={newprofile.MotherLastName}
                      onChange={this.changeForm}
                    />

                    <TextField
                      label="Teléfono"
                      id="CellPhoneNumber"
                      value={newprofile.CellPhoneNumber}
                      mask="+56\900000000"
                      onChange={this.changeForm}
                      useMaskedValue
                    />
                    <DateField
                      defaultValue={this.props.profile && this.props.profile.BirthDate && new Date(this.props.profile.BirthDate)}
                      label="Fecha de Nacimiento"
                      id="BirthDate"
                      type="date"
                      max={new Date()}
                      onChange={this.changeForm}
                    />

                    <SelectField
                      label="Estado Civil"
                      id="MaritalCmbx"
                      dataSource={this.props.listaEstadoCivil}
                      onValueChanged={(item) => this.handleChange(item, item.value)}
                      displayExpr="Text"
                      valueExpr="Cod"
                      defaultValue={newprofile.MaritalStatus.Id !== null && newprofile.MaritalStatus.Id}
                    />

                    <SelectField
                      label="Región"
                      id="regionCmbx"
                      placeholder="Seleccione .."
                      dataSource={this.props.listaDirecciones}
                      onValueChanged={(item) => this.handleChange(item, item.value)}
                      displayExpr="DescripcionRegion"
                      valueExpr="IdRegion"
                      searchEnabled
                      defaultValue={newprofile.Address.Region && this.props.listaDirecciones.filter((item) => item.DescripcionRegion === newprofile.Address.Region).map((r) => r.IdRegion)[0]}
                    />

                    <SelectField
                      label="Comuna"
                      id="comunaCmbx"
                      placeholder="Seleccione .."
                      dataSource={this.props.listaComuna}
                      onValueChanged={(item) => this.handleChange(item, item.value)}
                      displayExpr="DescripcionCommuna"
                      valueExpr="IdComuna"
                      searchEnabled
                      disabled={this.state.comunaDisabled}
                      defaultValue={newprofile.Address.Commune && this.props.listaComuna.filter((item) => item.DescripcionCommuna === newprofile.Address.Commune).map((r) => r.IdComuna)[0]}
                    />

                    <TextField
                      label="Calle"
                      id="Street"
                      value={newprofile.Address.Street}
                      onChange={this.changeForm}
                      maxLength={60}
                    />

                    <NumberField
                      label="Número"
                      id="Number"

                      value={newprofile.Address.Number ? Number(newprofile.Address.Number) : null}
                      onChange={this.changeForm}
                      skipValidation
                      maxLength={15}
                    />
                  </div>
                </div>

                <div className="datos dx-form-group-with-caption dx-form-group dx-group-colcount-1">
                  <span className="dx-form-group-caption datos-title">Datos previsonales</span>
                  <div className="dx-form-group-content">
                    <SelectField
                      label="Salud"
                      id="IsapreCmbx"
                      placeholder="Seleccione .."
                      dataSource={this.props.listaIsapres}
                      onValueChanged={(item) => this.handleChange(item, item.value)}
                      displayExpr="Isapre"
                      valueExpr="CodigoIsapre"
                      searchEnabled
                      defaultValue={newprofile.LegalDiscount.Isapre && newprofile.LegalDiscount.Isapre.Id}
                    />

                    <SelectField
                      label="AFP"
                      id="AfpCmbx"
                      placeholder="Seleccione .."
                      dataSource={this.props.listaAfp}
                      onValueChanged={(item) => this.handleChange(item, item.value)}
                      displayExpr="Text"
                      valueExpr="Cod"
                      searchEnabled
                      defaultValue={newprofile.LegalDiscount.AFP.Id ? newprofile.LegalDiscount.AFP.Id : null}
                    />
                  </div>
                </div>

                <div className="datos dx-form-group-with-caption dx-form-group dx-group-colcount-1">
                  <span className="dx-form-group-caption datos-title">Datos laborales</span>
                  <div className="dx-form-group-content">
                    <SelectField
                      label="Ocupación"
                      id="ProfesionCmbx"
                      placeholder="Seleccione .."
                      dataSource={this.props.listaProfesiones}
                      onValueChanged={(item) => this.handleChange(item, item.value)}
                      displayExpr="Ocupacion"
                      valueExpr="CodigoProfesion"
                      searchEnabled
                      defaultValue={newprofile.LaborInformation.Ocupation && newprofile.LaborInformation.Ocupation.Id}
                    />

                    <SelectField
                      label="Rubro"
                      id="SectorCmbx"
                      placeholder="Seleccione .."
                      dataSource={this.props.listaRubro}
                      onValueChanged={(item) => this.handleChange(item, item.value)}
                      displayExpr="Rubro"
                      valueExpr="Codigo"
                      searchEnabled
                      defaultValue={newprofile.LaborInformation.Sector && newprofile.LaborInformation.Sector.Id}
                    />

                    <SelectField
                      label="Jornada de Trabajo"
                      id="TipoJornadaCmbx"
                      placeholder="Seleccione .."
                      dataSource={this.props.listaTipoJornada}
                      onValueChanged={(item) => this.handleChange(item, item.value)}
                      displayExpr="Jornada"
                      valueExpr="Codigo"
                      defaultValue={newprofile.LaborInformation.DayType && newprofile.LaborInformation.DayType.Id}
                      searchEnabled
                    />
                  </div>
                </div>

                <div className="datos dx-form-group-with-caption dx-form-group dx-group-colcount-1">
                  <span className="dx-form-group-caption datos-title">Datos de pago</span>
                  <div className="dx-form-group-content">
                    <SelectField
                      label="Banco"
                      id="BancosCmbx"
                      placeholder="Seleccione .."
                      dataSource={this.props.listaBancos}
                      onValueChanged={(item) => this.handleChange(item, item.value)}
                      displayExpr="Banco"
                      valueExpr="Codigo"
                      searchEnabled
                      defaultValue={newprofile.Payment.Bank && newprofile.Payment.Bank.Id}
                    />

                    <SelectField
                      label="Tipo de Cuenta"
                      id="TipoCuentaCmbx"
                      placeholder="Seleccione .."
                      dataSource={this.props.listaTiposCuenta}
                      onValueChanged={(item) => this.handleChange(item, item.value)}
                      displayExpr="Cuenta"
                      valueExpr="Codigo"
                      searchEnabled
                      value={newprofile.Payment.AccountType.Id}
                      defaultValue={newprofile.Payment.AccountType && newprofile.Payment.AccountType.Id}
                      allowSearch={false}
                      isValid={this.state.tipoCtavalid}
                    />

                    <NumberField
                      label="Número de Cuenta"
                      id="AccountNumber"
                      maxLength={15}
                      isValid={this.state.nroCtavalid}
                      onValueChanged={this.changeForm}
                      validationError={{ message: "Debe completar número de cuenta si indicó el banco" }}
                      value={newprofile.Payment.AccountNumber ? Number(newprofile.Payment.AccountNumber) : null}
                    />
                  </div>
                </div>
              </div>
            </ValidationGroup>

            {newprofile.Rut != null && this.renderGrupoFamiliar()}
          </div>


        </div>
        <div className="col-12" style={{ marginTop: 20, marginBottom: 5, marginLeft: -13 }}>
          <Button
            text="Guardar cambios"
            type="success"
            disabled={!this.isValid()}
            onClick={this.doUpdateMyData}
          />
        </div>


      </div>

    );
  }
}

const mapStateToProps = (state) => ({

  isLoading: state.misDatos.isLoading,
  UserInfo: state.global.userData,
  profile: state.misDatos.profile,
  preventNavigation: state.global.preventNavigation,
  mailChanged: state.misDatos.mailChanged,
  NewEmail: state.misDatos.NewEmail,

  // Listas

  listaAfp: state.global.listaAfp,
  listaDirecciones: state.global.listaDirecciones,
  listaEstadoCivil: state.global.listaEstadoCivil,
  listaBancos: state.global.listaBancos,
  listaTipoJornada: state.global.listaTipoJornada,
  listaRubro: state.global.listaRubro,
  listaComuna: state.global.listaComuna,
  listaParentesco: state.global.listaParentesco,
  listaProfesiones: state.global.listaProfesiones,
  listaTiposCuenta: state.global.listaTiposCuenta,
  listaIsapres: state.global.listaIsapres,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(MisDatos);
